import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

export const FormContainer = styled.form`
  width: 100%;
`;

export const GiftCardImageContainer = styled.div`
  width: 100%;
  max-width: 300px;
  height: 162px;
`;

export const ModalBody = styled.div`
  margin-top: 10vh;
  ${Styles.desktop`
      margin-top: 2vh;
   `}
`;

export const BalanceDisclaimer = styled.p`
  margin: ${primitive.$spacing6} 0;
  /* font: ${brandFont.hero}; */
  text-align: center;
`;
